import { InfoItem } from "@/components/info-item";
import { useAppSelector } from "@/app/appStore";
import { selectSelectedEvent } from "@/entities/annotation";
import { displayUUID, formatAbsoluteCoordinates } from "@/shared";
import { ANNOTATION_TYPES } from "@/entities/annotation/model/consts";
import { formatTimestamp, getHandSide } from "../../lib/helpers";

const ProximityTimeRangeEventDetails = () => {
  const selectedEvent = useAppSelector(selectSelectedEvent);

  if (
    !selectedEvent ||
    selectedEvent.type !== ANNOTATION_TYPES.PROXIMITY_TIME_RANGES
  ) {
    return null;
  }

  const pinCoordinates = formatAbsoluteCoordinates(
    selectedEvent?.pinCoordinates.relativeX,
    selectedEvent?.pinCoordinates.relativeY,
    selectedEvent.cameraImageWidth,
    selectedEvent.cameraImageHeight
  );

  return (
    <>
      <InfoItem label="Event type" value="Proximity Time Ranges Annotation" />
      <InfoItem
        label="Journey ID"
        copyValue={selectedEvent?.journeyId}
        value={displayUUID(selectedEvent?.journeyId)}
      />
      <InfoItem
        label="Order ID"
        value={displayUUID(selectedEvent.orderId)}
        copyValue={selectedEvent.orderId}
      />
      <InfoItem
        label="Proximity Annotation ID"
        value={
          selectedEvent.proximityId
            ? displayUUID(selectedEvent.proximityId)
            : undefined
        }
        copyValue={selectedEvent.proximityId}
      />
      <InfoItem
        label="Annotation ID"
        value={selectedEvent.id ? displayUUID(selectedEvent.id) : undefined}
        copyValue={selectedEvent.id}
      />
      <InfoItem
        label="Timestamp"
        value={
          selectedEvent?.timestamp && formatTimestamp(selectedEvent?.timestamp)
        }
        copyValue={selectedEvent?.timestamp}
      />
      <InfoItem label="Hand" value={getHandSide(selectedEvent.handId)} />
      <InfoItem label="Pin coordinates (x,y)" value={pinCoordinates} />
      <InfoItem
        label="Camera image dimensions"
        value={`${selectedEvent?.cameraImageWidth}x${selectedEvent?.cameraImageHeight}`}
      />
      <InfoItem label="Camera ID" value={selectedEvent?.cameraId} />
      <InfoItem label="Calibration ID" value={selectedEvent?.calibrationId} />
      <InfoItem
        multiRow
        label="Before range start time"
        value={selectedEvent?.beforeRangeStartTime}
      />
      <InfoItem
        multiRow
        label="Before range end time"
        value={selectedEvent?.beforeRangeEndTime}
      />
      <InfoItem
        multiRow
        label="After range start time"
        value={selectedEvent?.afterRangeStartTime}
      />
      <InfoItem
        multiRow
        label="After range end time"
        value={selectedEvent?.afterRangeEndTime}
      />
      <InfoItem label="Gondola name" value={selectedEvent?.gondolaName} />
      <InfoItem label="Gondola ID" value={selectedEvent?.gondolaId} />
      <InfoItem label="Planogram ID" value={selectedEvent?.planogramId} />
      <InfoItem label="Note" value={selectedEvent.notes} />
    </>
  );
};

export default ProximityTimeRangeEventDetails;
